import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import Icon from './icon.vue'
import { i18n } from './i18n.js'
import router from './router'
import store from './store/store'
import moment from 'moment'

// Moment
window['moment'] = moment
moment.locale('da')

// icon
Vue.component('icon', Icon)

Vue.filter('formatDate', function (date) {
  if (date) {
    let now = moment(new Date())
    let yesterday = moment().subtract(1, 'day')
    let dayBeforeYesterday = moment().subtract(2, 'day')
    let timeStr = window['moment'].utc(date).format('DD-MM-YYYY')

    if (moment(date).isSame(now, 'day')) {
      return 'I dag'
    } else if (moment(date).isSame(yesterday, 'day')) {
      return 'I går'
    } else if (moment(date).isSame(dayBeforeYesterday, 'day')) {
      return 'I forgårs'
    } else {
      return timeStr[0].toUpperCase() + timeStr.substring(1)
    }
  } else {
    return 'Ingen dato'
  }
})

Vue.filter('formatDateWeekDay', function (date) {
  if (date) {
    let now = moment(new Date())
    let yesterday = moment().subtract(1, 'day')
    let dayBeforeYesterday = moment().subtract(2, 'day')
    // let timeStrRecent = window['moment'].utc(date).format('dddd[s]')

    if (moment(date).isSame(now, 'day')) {
      return 'I dag'
    } else if (moment(date).isSame(yesterday, 'day')) {
      return 'I går'
    } else if (moment(date).isSame(dayBeforeYesterday, 'day')) {
      return 'I forgårs'
    } else {
      let timeStr = window['moment'].utc(date).format('ddd DD[/]MM YYYY')
      return timeStr[0].toUpperCase() + timeStr.substring(1)
    }
  } else {
    return 'Ingen dato'
  }
})

Vue.filter('formatDateWithTime', function (date) {
  if (date) {
    let now = moment(new Date())
    let yesterday = moment().subtract(1, 'day')
    let dayBeforeYesterday = moment().subtract(2, 'day')
    // let weekday = window['moment'].utc(date).local().format('ddd')
    let timeStr = window['moment'].utc(date).format('[kl.] HH[.]mm')
    if (moment(date).isSame(now, 'day')) {
      return 'I dag ' + timeStr
    } else if (moment(date).isSame(yesterday, 'day')) {
      return 'I går ' + timeStr
    } else if (moment(date).isSame(dayBeforeYesterday, 'day')) {
      return 'I forgårs ' + timeStr
    } else {
      let timeStr = window['moment'].utc(date).format('ddd DD[-]MM[-]YYYY [kl.] HH[.]mm')
      return timeStr[0].toUpperCase() + timeStr.substring(1)
    }
  } else {
    return 'Ingen dato'
  }
})

Vue.config.productionTip = false

Vue.prototype.$getIconNameFromProfileName = (profileName) => {
  switch (profileName.toLowerCase()) {
    case 'jernbane':
      return 'infrastruktur-jernbane';
    case 'konstruktioner':
      return 'infrastruktur-konstruktion';
    case 'veje':
      return 'infrastruktur-vej';
    default:
      return 'byggeri';          
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
